module.exports = {
  SET_SPINNER_VISIBILITY: 'SET_SPINNER_VISIBILITY',
  SET_SELECTED_LANGUAGE: 'SET_SELECTED_LANGUAGE',
};
